package diana.soleil.design.iraniancanadienbazzar.core.firebase

/**
 * Holds the platform's native Google **ID-token** provider (Android Credential Manager / iOS
 * GoogleSignIn / web popup), injected from the entry point like the other platform capabilities
 * ([LocationController], image picking, …). `null` means this platform has no wired Google flow yet,
 * so the sign-in screens hide the Google button (no dead affordance). The token is exchanged for a
 * Firebase session by [AuthService.signInWithGoogle]. The provider returns `null` when the user
 * cancels or the platform flow fails.
 */
class GoogleSignInController(
    val provideIdToken: (suspend () -> String?)? = null,
) {
    val isAvailable: Boolean get() = provideIdToken != null
}
